import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    title: "Who we are",
    paragraphs: [
      "SefKam Digital Solutions (\"SefKam\", \"we\", \"us\") operates the website sefkam.com. We build software, AI and automation solutions for businesses. This policy describes how we handle personal data collected through this website.",
    ],
  },
  {
    title: "What data we collect",
    paragraphs: ["We keep data collection deliberately minimal. Through this website we collect:"],
    items: [
      "Contact form data: your name, email address, company (optional), and the message you send us.",
      "Technical data: basic server logs (such as IP address, browser type and pages requested) generated automatically when you visit the site, used for security and operation of the service.",
    ],
  },
  {
    title: "How we use your data",
    paragraphs: ["We use the data you provide solely to:"],
    items: [
      "Respond to your enquiry and communicate with you about potential or ongoing work.",
      "Operate, secure and improve this website.",
      "Comply with legal obligations where applicable.",
    ],
  },
  {
    title: "Legal basis for processing",
    paragraphs: [
      "Where the EU General Data Protection Regulation (GDPR) applies, we process contact form data on the basis of our legitimate interest in responding to business enquiries (Art. 6(1)(f) GDPR), and — where an enquiry leads to a contract — on the basis of pre-contractual steps taken at your request (Art. 6(1)(b) GDPR).",
    ],
  },
  {
    title: "How your data is stored and shared",
    paragraphs: [
      "Contact form submissions are stored in our database and forwarded to our team inbox via an email delivery provider. We do not sell your personal data, and we do not share it with third parties for marketing purposes.",
      "We use a small number of service providers (hosting and email delivery infrastructure) to operate this website. These providers process data on our behalf only to the extent necessary to provide their services.",
    ],
  },
  {
    title: "Cookies and tracking",
    paragraphs: [
      "This website does not use advertising cookies, cross-site tracking or third-party analytics profiles. Any cookies used are strictly limited to what is technically necessary to serve the website.",
    ],
  },
  {
    title: "Data retention",
    paragraphs: [
      "We retain contact enquiries for as long as needed to handle your request and any follow-up business relationship, after which they are deleted. Server logs are retained for a short period for security purposes and then discarded.",
    ],
  },
  {
    title: "Your rights",
    paragraphs: ["Depending on your location, you may have the right to:"],
    items: [
      "Request access to the personal data we hold about you.",
      "Request correction or deletion of your data.",
      "Object to or request restriction of processing.",
      "Lodge a complaint with a supervisory authority.",
    ],
  },
  {
    title: "Contact",
    paragraphs: [
      "To exercise any of these rights, or for any privacy question, email us at contact@sefkam.com. We will respond within a reasonable timeframe.",
    ],
  },
  {
    title: "Changes to this policy",
    paragraphs: [
      "We may update this policy as our services evolve. The date at the top of this page reflects the latest revision. Material changes will be highlighted on this page.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      seo={{
        title: "Privacy Policy | SefKam Digital Solutions",
        description: "How SefKam Digital Solutions collects, uses and protects personal data submitted through sefkam.com.",
        path: "/privacy",
      }}
      eyebrow="Legal"
      title="Privacy Policy"
      updated="June 2026"
      intro="Your privacy matters to us. This policy explains, in plain language, what data we collect through sefkam.com, why we collect it, and the rights you have over it."
      sections={SECTIONS}
      testId="privacy-page"
    />
  );
}
